<template>
  <div class="hello screen-spacing pb-5">
    <h1>Menu</h1>
      <SelectVenue ref="venueDropDown" @updateVenue="updateVenue"/>
      <div v-if="venue_id!=0" class="mt-4">
        <ul v-if="canEditMenu" class="nav custom-tabs mb-3 border-dark border-bottom border-1" role="tablist">
  <li class="nav-item" role="presentation">
    <button class="nav-link" :class="{ active: activeTab === 'header' }" @click="activeTab = 'header'">
     Manage Headers
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" :class="{ active: activeTab === 'menu' }" @click="activeTab = 'menu'">
      Manage Menu
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" :class="{ active: activeTab === 'import' }" @click="activeTab = 'import'">
      Import Menu
    </button>
  </li>
  
</ul>

<div v-if="activeTab === 'header'">
  <!-- Manage Menu Content -->
  <div>
      <!-- Manage Menu Content Goes Here -->
      <button 
          type="button" 
          class="btn btn-primary mb-3" 
          v-on:click="toggleAddHeader"
        >
          {{this.addHeaderToggle? 'Cancel Add': 'Add New Header'}}
        </button>
      <div v-if="this.addHeaderToggle">
        <label class="me-2 h4 mt-3 screen-spacing" for="dropdown">Add New Header:</label>
            <div class="input-group my-2">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="isLocationSpecific"  id="flexCheckDefault">
          <label class="form-check-label" for="flexCheckDefault">
          Is location specific?
          </label>
          <button class="tooltip-btn " type="button" v-on:click="alertLocationInfo()" >
            <span class="question-mark">?</span>
          </button>
       </div>
       <div class="ms-3">
                <SelectBar v-if="venue_id!='' && venue_id!='0' && isLocationSpecific" :venueId="venue_id" :liveOrder='true' :includeHeader='false' class="mb-3" ref="barDropDown" @updateBar="updateBar" />
       </div>
      </div>
      <div class="input-group mb-3">
        
        <input 
          type="text" 
          v-model="newHeader" 
          class="form-control" 
          placeholder="Enter header name"
        />
        <input 
          v-model="tax_percentage" 
          type="number" 
          placeholder="Tax %" 
          class="form-control"
          min="0" 
          step="1"
        />
        <button 
          type="button" 
          class="btn btn-primary" 
          v-on:click="saveHeader"
        >
          Save
        </button>
      </div>
      </div>


      <div class="mb-3">
        <h5>Headers</h5>
        <p class="text-muted fst-italic mt-3" v-if="itemHeaders.length===0">No headers available. Add one above to get started.</p>
        <div class="d-flex flex-wrap gap-2">
          <h4 v-for="header in itemHeaders"  :key="header._id">
            <button
            disabled
            :class="['btn', 'badge', ]"
          >
            {{ header.name }}
          </button>
          </h4>
          
        </div>
      </div>


      <div>
        <button 
          type="button" 
          class="btn btn-primary" 
          v-on:click="toggleEditHeaders"
        >
          {{this.editHeaders? 'Cancel Edit': 'Update Headers'}}
        </button>
      </div>

        <div v-if="editHeaders">
       <div v-for="(header,itemHeaderIndex) in itemHeaders" :key="'header_'+itemHeaderIndex" class="header-group w-100 mt-3 ">
         <div class="border-dark border-bottom border-2">
            <input 
            v-model="header.name" 
            type="text" 
            class="form-control d-inline-block w-25" 
           
    />
    <input
            v-model="header.tax_percentage" 
            type="text" 
            class="form-control d-inline-block w-25 ms-2" 
            placeholder="Tax %" 
    />
    <div class="form-check my-2">
          <input class="form-check-input" type="checkbox" v-model="header.is_location_specific"  id="flexCheckDefault">
          <label class="form-check-label" for="flexCheckDefault">
          Is location specific?
          </label>
       </div>
               <SelectBar v-if="venue_id!='' && venue_id!='0' && header.is_location_specific" :loadBar="editHeaders" :venueId="venue_id" :loadValue="header.location_ID" :liveOrder='true' :includeHeader='false' class="mb-3" :ref='"barDropDown"+itemHeaderIndex' @updateBar="updateBarInArray($event, itemHeaderIndex)"/>
          </div>   
            
    
       </div>
       <button 
          type="button" 
          class="btn btn-primary mt-2" 
          v-on:click="updateAllHeaders()"
        >
          Save
        </button>
      </div>
    </div>
</div>
<div v-else-if="activeTab === 'menu'">
  <!-- Edit Headers Content -->
  <div>
      <!-- Edit Headers Content Goes Here -->
      
      <div class="mb-3">
      <h5>Headers</h5>
      <div class="d-flex flex-wrap gap-2">
          <button
            v-for="header in itemHeaders"
            :key="header._id+'-filter'"
            @click="toggleHeaderFilter(header._id)"
            :class="['btn', 'btn-sm', 'rounded-pill', isHeaderActive(header._id) ? 'btn-dark text-white' : 'btn-outline-secondary']"
          >
            {{ header.name }}
          </button>
        </div>
      </div>



      <!-- 🔍 Search Bar -->
      <div class="mb-3">
      <h5>Item Search</h5>
      <div class="input-group mb-3" style="max-width: 300px;">
        <span class="input-group-text">
         <i class="ph-bold ph-magnifying-glass"></i>
        </span>
        <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          placeholder="Search by name of item"
        />
      </div>
      </div>
      
      
      <div v-for="(header,headerIndex) in enrichHeaders" :key="'header_'+headerIndex" class="header-group">
          <label :for="'for_'+header" class=" h3 header-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2">{{header.name}}
              <button v-if="isBusiness" type="button" ref="action"  class="btn btn-outline-primary btn-outline-pulse ms-2" data-bs-toggle="modal" data-bs-target="#newItemModal" v-on:click="openModal(header.name,'Add '+header.name,header)">Add Item</button>
       <button v-if="isBusiness" type="button" ref="action"  class="btn btn-outline-primary btn-outline-pulse ms-2" data-bs-toggle="modal" data-bs-target="#newModifierModal" v-on:click="openModifierModal(header)">Add Modifier</button>

       <button v-if="isBusiness" type="button" ref="action" class="btn btn-outline-warning ms-2" @click="toggleAllVip(header._id, true)">Mark All VIP</button>
       <button v-if="isBusiness" type="button" ref="action" class="btn btn-outline-secondary ms-2" @click="toggleAllVip(header._id, false)">Clear VIP</button>

       <button v-if="isBusiness" type="button" ref="action"  class="btn btn-outline-danger btn-outline-delete ms-2" v-on:click="deleteHeader(header)">Delete Header</button></label>

       <div>{{header.tax_percentage?`Tax : ${header.tax_percentage}%`:''}}</div>
       <div>{{header.is_location_specific? getLocationName(header.location_ID):''}}</div> 
         <div v-if="header.modifiers.length>0" class="row mt-4">
            <label class=" form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2">Modifiers</label>
         <div v-for="(modifier,index) in header.modifiers" :key="'modifier_'+index" class="card m-3" style="width: 18rem;">
          <div class="card-body">
            <h5 class="card-title mt-1">{{modifier.name}} - {{modifier.isMultiSelection?"Multi":"Single"}} {{modifier.is_item_specific? '- '+ menu.filter(item => item._id === modifier.relationship_ID )[0].name:""}}</h5>
            <div v-for="(answer,index) in modifier.answer_list" :key="'answer'+index" class="m-2"> 
              <p class="card-text text-muted fs-6">{{answer.text}}{{modifier.adjustsPayment?'- $'+answer.cost:''}}</p>
            </div>
            <div class="btn-group" role="group">
              <button type="button" v-on:click="toggleEnableModifier(modifier)" class="btn btn-primary me-2">{{modifier.is_disabled?"Disabled":'Enabled'}}</button>
              <button v-if="isBusiness" type="button" class="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#newModifierModal" v-on:click="openEditModifier(modifier,header)">Edit</button>
              <button v-if="isBusiness" type="button" v-on:click="deleteModifier(modifier)" class="btn btn-primary">Delete</button>
            </div>
          </div>
         </div>
         </div>
        

        <div class="row mt-4" v-if="header.items.length>0">
          <label :for="'for_'+header" class="h5 subheader-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2">Items</label>
         <div v-for="(item,index) in header.items" :key="'item_'+index" class="card m-3" style="width: 18rem;">
          <div class="card-body">
            <img :src="item.image || require('../../assets/No_Image.jpg')" class="card-picture-size" :alt="item.name">
            <h5 class="card-title mt-1">{{item.name}} {{item.is_vip? "(VIP)":""}}</h5>
            <p class="card-text text-muted fs-6">${{item.cost}}</p>
            <p class="card-text fixedTextBox">{{item.description==""?"N/A":item.description.length >= 120 ? item.description.slice(0, 120) + '...' : item.description}}</p>
            <div class="btn-group" role="group">
              <button type="button" v-on:click="toggleEnable(item)" class="btn btn-primary me-2">{{item.is_disabled?"Disabled":'Enabled'}}</button>
              <button v-if="isBusiness" type="button" class="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#newItemModal" v-on:click="openEditModal(item,'Cocktail')">Edit</button>
              <button v-if="isBusiness" type="button" v-on:click="deleteItem(item)" class="btn btn-primary">Delete</button>
            </div>
          </div>
        </div>
        </div>
        
        </div>
    </div>
</div>
<div v-if="activeTab === 'import'">
 <div v-if="selectedJob===''">
    <!-- Image Upload Section -->
    <div class="image-upload-section">
      <h3>Import Menu Image</h3>
      <p>
        Please upload a clear image of your menu. Make sure the text is readable and properly lit. 
        If the sections are formatted differently, upload separate images for each section.
      </p>
      <div class="row">
        <div class="col">
          <input 
        type="file" 
        accept="image/*" 
        @change="handleImageUpload" 
        id="menuImageUpload" 
        class="form-control w-100"
      />
        </div>
        <div class="col"><button class="btn btnAccent" @click="submitImage">Submit Image</button>
        <button class="tooltip-btn " type="button" v-on:click="submissionInfo" >
      <span class="question-mark">?</span>
    </button>
        </div>
      </div>
      
      
      
    </div>

    <!-- Menu Job List -->
    <div class="menu-job-list">
      <h3>Current Menu Jobs</h3>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Created At</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="job in menuJobs" :key="job._id">
            <th th scope="row">{{ job.imageName ||job.result?.cafe_name || 'N/A' }}</th>
            <td>{{ new Date(job.createdAt).toLocaleString() }}</td>
            <td>{{ job.status }}</td>
            <td>
              <button v-if="job.status === 'complete'" @click="setSelectedJob(job)" class="btn btnAccent">
                Import Menu
              </button>
              <span v-else-if="job.status === 'error'">Error</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else>
     <MenuEdit :jobData="selectedJob" :venue_id="venue_id" @goBack="goBack" />
  </div>
 
</div>
    </div>
<!-- Modal -->
<div class="modal fade" id="newItemModal" ref="modal" tabindex="-1" aria-labelledby="newbathroomModalLabel" aria-hidden="true">
  <NewMenuItem :itemType="newItemType" :currentHeaderUpdate="currentHeaderUpdate" :venue_id="venue_id" :editItem="editItem" @addItem="addItem" @updateItem="updateItem" @clearEdit="clearEdit">
   {{displayedModalString}}
  </NewMenuItem>
</div>

<div class="modal fade" id="newModifierModal" ref="modal" tabindex="-1" aria-labelledby="newbathroomModalLabel" aria-hidden="true">
  <AddModifier :venue_id="venue_id" :currentHeaderUpdate="currentHeaderUpdate" :currentItems="currentItems" :editmodifier="editmodifier" @addNewModifier="addNewModifier" @updateModifier="updateModifier" @clearEdit="clearEdit">
   {{displayedModifierString}}
  </AddModifier>
</div>
    
  </div>
</template>

<script>
import NewMenuItem from "../../components/modals/newMenuItem.vue"
import AddModifier from "../../components/modals/AddModifier.vue"
import ItemService from "../../api/menuItems.js"
import ItemheaderService from "../../api/itemHeader.js"
import ModifierService from "../../api/modifiers"
import MenuJobService from "../../api/menuJob"
import BarService from "../../api/bar.js"
import SelectVenue from "../../components/SelectVenue.vue"
import SelectBar from "../../components/SelectBar.vue"
import swal from 'sweetalert';
import MenuEdit from './MenuEdit.vue';

export default {
  name: 'ItemMenu',
  components:{
    NewMenuItem,
    SelectVenue,
    AddModifier,
    SelectBar,
    MenuEdit 
  },
  data() {
    return {
        newItemType:"",
        displayedModalString:"",
        displayedModifierString:"",
        editItem:"",
        editmodifier:"",
        editModifierModal:"",
        menu:[],
        modifiers:[],
        itemHeaders:[],
        venue_id:0,
        currentHeaderUpdate:"",
        currentItems:[],
        newHeader:"",
        isLocationSpecific: false,
        location_ID:'',
        tax_percentage:"",
        editHeaders:false,
        activeTab:'header',
        addHeaderToggle:false,
        activeHeaderIds:'',
        searchQuery:'',
        bars:[],
        menuJobs:[],
        selectedJob:"",
        selectedImage:""
        
        
    };
  },
  mounted(){
    if(!this.canEditMenu){
      this.activeTab = 'menu'
    }
  },
  methods:{
    async toggleAllVip(headerId, isVip) {
      try {
        await ItemService.markAllVip(headerId, isVip);

        // Update local menu items that belong to this header
        this.menu.forEach(item => {
          if (item.item_header_ID === headerId) {
            item.is_vip = isVip;
          }
        });

        swal(`All items under this header were ${isVip ? 'marked' : 'cleared'} as VIP!`);
      } catch (error) {
        console.error("VIP toggle failed:", error);
        swal("Something went wrong updating VIP status!");
      }
    },
    submissionInfo(){
      swal("Menu Submission", 
          "Upload your menu directly to our website! We support .JPEG, .JPG, .PNG, and .WEBP files."
        ); 
    },
    handleImageUpload(event) {
      // Handle image file selection
      this.selectedImage = event.target.files[0];
    },
    submitImage() {
      // Submit the selected image to the backend API
      if (!this.selectedImage) {
        swal('Please select an image to upload');
        return;
      }

      const body = {
        image:this.selectedImage,
        venueID:this.venue_id
      }
      MenuJobService.saveNewMenuJob(body).then(data=>{
        swal("Job Sent!","Come back in 5-10 minutes.")
        this.menuJobs.push(data)
      })

    },
    setSelectedJob(job){
      this.selectedJob = job
    },
    goBack(){
       this.selectedJob = ''
    },
    getLocationName(locationID){
      if(locationID ===this.venue_id){
        return "For Tables Only"
      }
      else{
         const match = this.bars.find(bar => bar._id === locationID);
      return match ? 'For '+ match.name + ' Only' : '';
      }
    },
     alertLocationInfo(){
      swal(
        "Location-Specific Header",
        "Enable this if the header should only be available at certain locations. For example, entrees may only be served at tables, or only one location may have a blender for frozen drinks."
      );
    },
    isHeaderActive(id) {
      return this.activeHeaderIds === id
    },
    toggleHeaderFilter (id) {
      if (this.activeHeaderIds===id) {
        this.activeHeaderIds = ''
      } else {
        this.activeHeaderIds= id
      }
    },
    toggleAddHeader(){
      this.addHeaderToggle = !this.addHeaderToggle
    },    
    updateBarInArray(e, index) {
      this.itemHeaders[index].location_ID = e.target.value
      console.log(typeof(this.location_ID))
    },

     async updateBar(e){
      this.location_ID = e.target.value
      console.log(typeof(this.location_ID))
    },
    toggleEditHeaders(){
      if(this.editHeaders){
        window.location.reload()
      }
      else{
        this.editHeaders = !this.editHeaders
      }
      
    },
    validateItemHeaders() {
    let isValid = true;

    this.itemHeaders.forEach((item, index) => {
      if (item.is_location_specific) {
        if (!item.location_ID || item.location_ID.trim() === '') {
          isValid = false;

          // Show SweetAlert error
          swal({
            icon: 'error',
            title: 'Missing Location',
            text: `Please select a location for item ${index + 1}.`,
          });
          return false;
        }
      } else {
        // Ensure location_ID is empty if not location specific
        item.location_ID = '';
      }
    });

    return isValid;
  },
    updateAllHeaders(){
      var valid = this.validateItemHeaders()
      if(valid){
        console.log(this.itemHeaders);
    const body = {updates:this.itemHeaders}

      ItemheaderService.updateAllItemheaders(body).then(()=>{

      this.editHeaders = false
        swal("Save successful!")
      })
      }
    },
        updateHeader(header){
    console.log(this.itemHeaders);
      ItemheaderService.updateItemheaderByID(header._id,header).then(item=>{
       var updateIndex = this.itemHeaders.findIndex((header => header._id === item._id))
      this.itemHeaders[updateIndex].name= item.name
      this.itemHeaders[updateIndex].tax_percentage= item.tax_percentage
      this.editHeaders = false
        swal("Save successful!")
      })
    },
    saveHeader(){
        if (isNaN(this.tax_percentage) && this.tax_percentage !== "") {
          swal("Please enter a valid tax percentage.");
          return;
        }
        if(this.isLocationSpecific && this.location_ID ===''){
          swal("Please select a location");
          return;
        }
      if(this.newHeader!=""){
        const headerObject = {
          venue_ID:this.venue_id,
          name: this.newHeader,
          is_vip:false,
          is_disabled: false,
          tax_percentage:this.tax_percentage,
          is_location_specific:this.isLocationSpecific,
          location_ID: this.isLocationSpecific ? this.location_ID: ''
          

        }
        ItemheaderService.saveNewItemheader(headerObject).then(header =>{
          this.itemHeaders.push(header)
          this.newHeader="";
          this.isLocationSpecific=false
          this.tax_percentage = ""
          swal("Save successful!")
        })
      }
      else{
          swal("Ensure there is a text in the header.")
      }
    },
    clearEdit(){
      this.editItem=""
      this.editmodifier=""
      this.editModifierModal=""
      this.currentHeaderUpdate=""
      this.currentItems= []
    },
    async updateVenue(e){
     this.venue_id = e.target.value;

    // Fetch all the data
    const menu = await ItemService.getAllItems(this.venue_id);
    const itemHeaders = await ItemheaderService.getAllItemheaders(this.venue_id);
    const modifiers = await ModifierService.getAllModifiers(this.venue_id);
    const bars = await BarService.getAllBars(this.venue_id)
    const menuJobs = await MenuJobService.getAllMenuJobs()

    // Update the state with the results
    this.menu = menu;
    this.itemHeaders = itemHeaders;
    this.modifiers = modifiers;
    this.bars = bars
    this.menuJobs = menuJobs
      
    },
     
    
    openEditModal(item,type){
      this.editItem=item;
      this.newItemType=type;
      this.displayedModalString="Edit "+item.name
    },
    openEditModifier(item,header){
      this.editmodifier=item;
      this.currentItems = header.items
      this.displayedModifierString="Edit "+item.name
    },
    openModal(type,displayString,header=""){
      this.currentHeaderUpdate = header
      this.newItemType=type;
      this.displayedModalString=displayString
//      this.$refs.action.click();
    },
    openModifierModal(header=""){
      this.currentHeaderUpdate = header
      this.currentItems = header.items
      this.displayedModifierString = "Create Modifier"
//      this.$refs.action.click();
    },
    async addItem(item){
      ItemService.saveNewItem(item).then(data=>{
        this.menu.push(data)
        this.currentHeaderUpdate = ""
         swal("Save successful!")
      })
    },
    async addNewModifier(item){
      ModifierService.saveNewModifier(item).then(data=>{
        this.modifiers.push(data)
         swal("Save successful!")
      })
    },

    async updateItem(data){
      ItemService.updateItemByID(data.id,data.item).then(item=>{
       var updateIndex = this.menu.findIndex((bar => bar._id === item._id))
      this.menu[updateIndex].name= item.name
      this.menu[updateIndex].description= item.description
      this.menu[updateIndex].image =item.image
      this.menu[updateIndex].cost =item.cost,
      this.menu[updateIndex].enable_special_instructions = item.enable_special_instructions
       this.menu[updateIndex].is_vip = item.is_vip
         swal("Save successful!")
      })
    },

    async updateModifier(data){
      ModifierService.updateModifierByID(data.id,data.modifier).then(item=>{
       var updateIndex = this.modifiers.findIndex((mod => mod._id === data.id))
      this.modifiers[updateIndex].name= item.name
      this.modifiers[updateIndex].adjustsPayment =item.adjustsPayment
      this.modifiers[updateIndex].answer_list =item.answer_list
      this.modifiers[updateIndex].isMultiSelection =item.isMultiSelection
      this.modifiers[updateIndex].item_header_id = item.item_header_id
      this.modifiers[updateIndex].relationship_ID = item.relationship_ID
      this.modifiers[updateIndex].venue_ID = item.venue_ID
      this.modifiers[updateIndex].is_item_specific = item.is_item_specific
      this.modifiers[updateIndex].is_disabled = item.is_disabled
      this.modifiers[updateIndex].isRequired = item.isRequired
         swal("Save successful!")
      })
    },


    toggleEnable(item){
        var toggle = {
          is_disabled:!item.is_disabled
        }
        ItemService.updateItemByID(item._id,toggle).then(()=>{
            item.is_disabled=!item.is_disabled
           swal("Item has been updated")
          })

    },
    toggleEnableModifier(item){
        var toggle = {
          is_disabled:!item.is_disabled
        }
        ModifierService.updateModifierByID(item._id,toggle).then(()=>{
            item.is_disabled=!item.is_disabled
           swal("Item has been updated")
          })

    },

     deleteItem(item){
      const index = this.menu.indexOf(item);
       swal({
    title: 'Are you sure you want to delete the '+ item.name+'?',
    text: 'You won\'t be able to revert this!',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      // If confirmed, show a success message
       ItemService.deleteItemByID(item._id).then(()=>{
            this.menu.splice(index,1)
            swal("delete successful")
        })
      // TODO: Perform the actual deletion action here
    } else {
      // Handle the cancellation
      swal('Your item is safe!');
    }
  });
    },
    deleteModifier(item){
      const index = this.modifiers.indexOf(item);
       swal({
    title: 'Are you sure you want to delete '+ item.name+' modifier?',
    text: 'You won\'t be able to revert this!',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      // If confirmed, show a success message
       ModifierService.deleteModifierID(item._id).then(()=>{
            this.modifiers.splice(index,1)
            swal("Delete successful!!")
        })
      // TODO: Perform the actual deletion action here
    } else {
      // Handle the cancellation
      swal('Your item is safe!');
    }
  });
    },
    deleteHeader(item){
      const index = this.itemHeaders.indexOf(item);
       swal({
    title: 'Are you sure you want to delete all '+ item.name+'?',
    text: 'You won\'t be able to revert this!',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      // If confirmed, show a success message
       ItemheaderService.deleteItemheaderID(item._id).then(()=>{
            this.itemHeaders.splice(index,1)
            this.activeHeaderIds=''
            swal("Delete successful!!")
        })
      // TODO: Perform the actual deletion action here
    } else {
      // Handle the cancellation
      swal('Your data is safe!');
    }
  });
    }
  },
  computed:{
    canEditMenu(){
      return sessionStorage.getItem("isBusiness") === "true"
    },
    enrichHeaders() {
      var itemHeaderArray =[]
      if(this.activeHeaderIds===''){
        itemHeaderArray= this.itemHeaders
      }
      else{
        itemHeaderArray= this.itemHeaders.filter(header => this.activeHeaderIds===header._id)
      }


      return itemHeaderArray.map((header) => {
        const filteredMenu = this.searchQuery===''? this.menu : this.menu.filter(searchItem => searchItem.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
        const associatedItems = filteredMenu.filter((item) => item.item_header_ID === header._id);
        const associatedModifiers = this.modifiers.filter((modifier) => modifier.item_header_id === header._id);

        return {
          ...header,
          items: associatedItems,
          modifiers: associatedModifiers,
        };
      });
    },
    isBusiness(){
      return sessionStorage.getItem('isBusiness') === "true";
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.fixedTextBox{
  height: 100px;
}
.custom-tabs .nav-link {
  color: black;
  font-weight: 600;
  border: none;
  border-bottom: 3px solid transparent;
  background-color: transparent;
  padding-bottom: 8px;
  transition: border-bottom 0.2s ease;
}

.custom-tabs .nav-link.active {
  border-bottom: 3px solid black;
  color: black;
}

.custom-tabs .nav-link:hover {
  border-bottom: 3px solid #ccc;
}
</style>
